import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Reservation} from '../../shared/models/reservation.model';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {tap} from 'rxjs/operators';
import {ApiConfigService} from './api.config.service';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';

@Injectable({providedIn: 'root'})
export class ReservationService {
  constructor(private http: HttpClient, private hoomvipStorage: HoomvipStorage, private apiConfigService: ApiConfigService, private cache: HttpCacheService) {
  }

  getReservation(): Observable<Reservation> {
    const code = this.hoomvipStorage.getCode();

    const url = this.apiConfigService.getReservationUrl();
    const key = `ReservationService:POST:${url}:code=${encodeURIComponent(code ?? '')}`;

    return this.cache.getOrSet<Reservation>(
      key,
      HTTP_CACHE_TTL_MS.REGULAR,
      () =>
        this.http.post<Reservation>(url, {code}).pipe(
          tap(res => this.hoomvipStorage.setApartment(res.data.apartment.id))
        )
    );

  }
}
